/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ImportRunDto } from './importRunDto';

/**
 * Compteurs d'une tâche d'import, agrégés sur toute la tâche. Les clés de countByErrorKey sont celles portées par les lignes.
 */
export interface ImportLineCountersDto {
    pending?: number;
    errors?: number;
    imported?: number;
    total?: number;
    countByErrorKey?: { [key: string]: number; };
    /** Exécution en cours ou dernière exécution ; absent si la tâche n'en a pas, ou si le tenant n'a pas le suivi d'exécution. */
    run?: ImportRunDto;
}
